import store from '@/store';
import router from '@/router';
import routes from './route';

//installs module
export default class CoreModule {

  static install() {
    routes.forEach(route => {
      router.addRoute(route);
    });
    this.installNameSpace();
    //add the module translations
    let enMap = new Map();
    enMap.set('dialog', () => import('@/modules/core/translations/en/dialog.json'));
    enMap.set('legal', () => import('@/modules/core/translations/en/legal.json'));
    enMap.set('snackbar', () => import('@/modules/core/translations/en/snackbar.json'));
    enMap.set('navbar', () => import('@/modules/core/translations/en/navbar.json'));
    enMap.set('core-site', () => import('@/modules/core/translations/en/core-site.json'));
    enMap.set('utils', () => import('@/modules/core/translations/en/utils.json'));
    enMap.set('components', () => import('@/modules/core/translations/en/components.json'));
    enMap.set('country', () => import('@/modules/core/translations/en/country.json'));
    enMap.set('common', () => import('@/modules/core/translations/en/common.json'));
    enMap.set('buttons', () => import('@/modules/core/translations/en/buttons.json'));
    enMap.set('enums', () => import('@/modules/core/translations/en/enums.json'));
    enMap.set('error-causes', () => import('@/modules/core/translations/en/error-causes.json'));
    enMap.set('patch', () => import('@/modules/core/translations/en/patch.json'));

    let deMap = new Map();
    deMap.set('dialog', () => import('@/modules/core/translations/de/dialog.json'));
    deMap.set('legal', () => import('@/modules/core/translations/de/legal.json'));
    deMap.set('snackbar', () => import('@/modules/core/translations/de/snackbar.json'));
    deMap.set('navbar', () => import('@/modules/core/translations/de/navbar.json'));
    deMap.set('core-site', () => import('@/modules/core/translations/de/core-site.json'));
    deMap.set('utils', () => import('@/modules/core/translations/de/utils.json'));
    deMap.set('components', () => import('@/modules/core/translations/de/components.json'));
    deMap.set('country', () => import('@/modules/core/translations/de/country.json'));
    deMap.set('common', () => import('@/modules/core/translations/de/common.json'));
    deMap.set('buttons', () => import('@/modules/core/translations/de/buttons.json'));
    deMap.set('enums', () => import('@/modules/core/translations/de/enums.json'));
    deMap.set('error-causes', () => import('@/modules/core/translations/de/error-causes.json'));
    deMap.set('patch', () => import('@/modules/core/translations/de/patch.json'));

    let translationMap = new Map();
    translationMap.set('en', enMap);
    translationMap.set('de', deMap);

    store.commit("translation/updateImportMap", translationMap);
  }

  static installNameSpace() {
    let globalNamespace = ['navbar', 'buttons', 'legal', 'common', 'patch', 'components', 'utils', 'dialog', 'snackbar', 'error-causes'];
    router.beforeEach(
      (to, from, next) => {

        let namespaces = globalNamespace;
        if(to.meta && to.meta.namespaces) {
          namespaces = namespaces.concat(to.meta.namespaces);
        }

        if(store.state.translation.namespaces) {
          namespaces = namespaces.concat(store.state.translation.namespaces);
        }

        store.commit("translation/updateNamespaces", namespaces)
        store.commit("translation/loadNamespaces")

        next();
    });
  }
}
